var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { ifDefined } from "lit/directives/if-defined.js";
import { commonCssStyles } from "../../global-styles.js";
import "../avatar-icon/AvatarIcon.js";
import { msg } from "@lit/localize";
let ProfileAvatar = class ProfileAvatar extends LitElement {
    constructor() {
        super(...arguments);
        this.selected = false;
        this.alert = false;
    }
    focus(options) {
        this.shadowRoot.getElementById("avatar-button").focus(options);
    }
    render() {
        return html `<button
      id="avatar-button"
      type="button"
      class="container ${classMap({
            selected: this.selected,
        })}"
      aria-label="${msg("User options menu")}"
    >
      <avatar-icon
        class="avatar-icon"
        initials="${ifDefined(this.initials)}"
        ?alert="${this.alert}"
        icon-size="big"
      ></avatar-icon>
      <svg
        class="chevron"
        width="12"
        height="7"
        viewBox="0 0 12 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.47852 5.7832C5.75977 6.08789 6.25195 6.08789 6.5332 5.7832L11.0332 1.2832C11.3379 1.00195 11.3379 0.509766 11.0332 0.228516C10.752 -0.0761719 10.2598 -0.0761719 9.97852 0.228516L6.01758 4.18945L2.0332 0.228516C1.75195 -0.0761719 1.25977 -0.0761719 0.978516 0.228516C0.673828 0.509766 0.673828 1.00195 0.978516 1.2832L5.47852 5.7832Z"
        />
      </svg>
    </button>`;
    }
};
// noinspection CssUnresolvedCustomProperty,CssNoGenericFontName
ProfileAvatar.styles = [
    commonCssStyles,
    css `
      .container {
        background-color: transparent;
        border-radius: 4px;
        border: none;
        padding: 0;
        display: inline-flex;
        align-items: center;
        gap: var(--spacing-2xs);
      }

      .container .chevron {
        fill: var(--dark-gray-color);
      }

      .container * {
        transition: var(--delay-transition75);
      }

      .container:hover {
        cursor: pointer;
      }

      .container:hover .avatar-icon::part(circlecontainer) {
        background-color: var(--tones-lavender60-color);
      }

      .container:active .avatar-icon::part(circlecontainer) {
        background-color: var(--tones-lavender70-color);
      }

      .container.selected .chevron {
        transform: rotate(180deg);
      }

      .container:focus-visible {
        outline: 2px solid var(--tones-lavender50-color);
        outline-offset: 6px;
      }
    `,
];
__decorate([
    property()
], ProfileAvatar.prototype, "initials", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], ProfileAvatar.prototype, "selected", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], ProfileAvatar.prototype, "alert", void 0);
ProfileAvatar = __decorate([
    customElement("profile-avatar")
], ProfileAvatar);
export { ProfileAvatar };
